import React from 'react'
import CookieConsent from "react-cookie-consent"

const Footer = () => (
  <CookieConsent>
    This website uses cookies to enhance the user experience. Using Google Analytics.
  </CookieConsent>
)

export default Footer